import { ReactNode } from 'react';
import { Typography } from '@mui/material';

function ResumeSectionLabel({ children }: { children: ReactNode }) {
  return (
    <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
      {children}
    </Typography>
  );
}

export default ResumeSectionLabel;
